"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdSetDraftCreateOnlyPropertiesToJSON = exports.AdSetDraftCreateOnlyPropertiesFromJSONTyped = exports.AdSetDraftCreateOnlyPropertiesFromJSON = exports.instanceOfAdSetDraftCreateOnlyProperties = void 0;
/**
 * Check if a given object implements the AdSetDraftCreateOnlyProperties interface.
 */
function instanceOfAdSetDraftCreateOnlyProperties(value) {
    var isInstance = true;
    isInstance = isInstance && "campaignId" in value;
    return isInstance;
}
exports.instanceOfAdSetDraftCreateOnlyProperties = instanceOfAdSetDraftCreateOnlyProperties;
function AdSetDraftCreateOnlyPropertiesFromJSON(json) {
    return AdSetDraftCreateOnlyPropertiesFromJSONTyped(json, false);
}
exports.AdSetDraftCreateOnlyPropertiesFromJSON = AdSetDraftCreateOnlyPropertiesFromJSON;
function AdSetDraftCreateOnlyPropertiesFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'campaignId': json['campaign_id'],
    };
}
exports.AdSetDraftCreateOnlyPropertiesFromJSONTyped = AdSetDraftCreateOnlyPropertiesFromJSONTyped;
function AdSetDraftCreateOnlyPropertiesToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'campaign_id': value.campaignId,
    };
}
exports.AdSetDraftCreateOnlyPropertiesToJSON = AdSetDraftCreateOnlyPropertiesToJSON;
